import styled from 'styled-components';

export const ShareMarkContainer = styled.div`
  position: absolute;
  z-index: 1;
  top: ${(props) => props.positionTop};
  right: ${(props) => props.positionRight};
`;
